<template>
  <div class="container mescroll-touch">
    <div class="square_banner">
      <div class="bannerBox">
        <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#333333">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index"
            @click="toBanner(item.Type, item.Url, item.Id)">
            <img class="banner-img" :src="baseURL + item.Img" />
          </van-swipe-item>
          <!-- <van-swipe-item @click="toLive()">
            <img class="banner-img" src="../../assets/images/banner1.jpg" />
          </van-swipe-item> -->
        </van-swipe>
      </div>
    </div>
    <div class="square_content" id="toTop">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <div class="square_warp">
          <div class="square_btn_item" @click="toACMEDReg">
            <img src="../../assets/images/square_header_acmed.png" />
            <span>会员招募</span>
          </div>
          <div class="square_btn_item" @click="toActivity">
            <img src="../../assets/images/square_header_activity.png" />
            <span>会议培训</span>
          </div>
          <div class="square_btn_item" @click="toACMED">
            <img src="../../assets/images/square_header_1new.png" />
            <span>投稿</span>
          </div>
          <div class="square_btn_item" @click="toLivelist">
            <img src="../../assets/images/square_header_2new.png" />
            <span>荟直播</span>
          </div>
          <div class="square_btn_item">
            <img src="../../assets/images/square_header_3new.png" />
            <span>荟文献</span>
            <wx-open-launch-weapp id="launchBtn" appid="wxcb4d8ecba843730e" path="pages/index/index">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    <!-- width: calc(100% / 4);
                    height: 80px; -->
                    background: orange;
                  }
                </style>
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>

        </div>
        <!-- <div class="square_circle">
          <div class="square_consult_title">
            <span class="title">推荐圈子</span>
            <div class="more" @click="toSquare">
              <span>查看更多</span>
              <van-icon class="icon" name="arrow" />
            </div>
          </div>
          <div class="square_circle_box">
            <div class="page_squareCircle_mask" @click="toSquare">
              <div class="mask_l">
                <img
                  src="https://dermatology-infectious-disease-api.yidao.pro/api/File/GetFileContent/2024%2F06%2F27%2F44d83f3f-3d87-4efa-a67d-44dbd0650fe6.jpg" />
              </div>
              <div class="mask_r">
                <div class="name van-multi-ellipsis--l2">华皮有约</div>
                <div class="join">
                  <van-icon class="icon" name="plus" />
                  <span>加入</span>
                </div>
              </div>
            </div>
            <div class="page_squareCircle_mask" @click="toSquare">
              <div class="mask_l">
                <img
                  src="https://dermatology-infectious-disease-api.yidao.pro/api/File/GetFileContent/2024%2F09%2F11%2Ff5a706b8-4ac1-4587-bb64-3ff9786170ff.jpg" />
              </div>
              <div class="mask_r">
                <div class="name van-multi-ellipsis--l2">研学中心</div>
                <div class="join">
                  <van-icon class="icon" name="plus" />
                  <span>加入</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="square_consult">
          <div class="square_consult_title">
            <span class="title">热门资讯</span>
          </div>
          <div class="square_consult_box">
            <div class="right_Consult" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  <span class="top" v-if="item.IsTop">置顶</span>{{ item.Title }}
                </div>
                <div class="info">
                  <div class="source_box">
                    <img class="source_icon" v-if="item.SourceImg" :src="baseURL + item.SourceImg" />
                    <span class="source_title van-ellipsis" v-if="item.Source">{{ item.Source }}</span>
                  </div>
                  <span class="time" v-if="item.PublishDate">{{
                    item.PublishDate.split(" ")[0]
                  }}</span>
                </div>
              </div>
              <div class="picture">
                <img :src="baseURL + item.Img" />
              </div>
            </div>
          </div>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import mixin from "../../common/mixin/mixins";
import MescrollVue from "mescroll.js/mescroll.vue";
import wx from "weixin-js-sdk";
import utils from "@/common/utils/utils";
export default {
  name: "Home",
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      bannerList: [],
      list: [],
      PageIndex: 0,
      PageSize: 6,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false,
      },
      mescrollUp: {
        // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 6, //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          warpId: "toTop",
          src: "./static/image/top_comm_icon@2x.png", // 回到顶部按钮的图片路径,支持网络图
        },
      },
    };
  },
  mixins: [mixin],
  components: {
    MescrollVue,
  },
  created() {
    this.getBanner();
    this.$store.commit("changeNavbarIndex", 0);
    this.initShare("华肤荟");
    document.title = "华肤荟";
  },
  methods: {
    getBanner() {
      this.$axios.get("/api/api/web/content/IndexBannerList").then((res) => {
        this.bannerList = res.Data;
      });
    },
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      this.$axios
        .post("/api/api/web/content/ContentArticleList", {
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
        })
        .then((res) => {
          if (PageIndex === 1) this.list = [];
          this.list = this.list.concat(res.Data.List);
          this.$nextTick(() => {
            this.mescroll.endSuccess(res.Data.List.length);
          });
        });
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调
    upCallback(page) {
      this.getList(page.num, page.size);
    },
    toDetail(info) {
      if (info.IsOuter) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: info.ArticleId,
          }).then(res => {
            location.href = info.OuterUrl;
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: info.ArticleId,
          }).then(res => {
            this.$router.push({
              path: "informationDetails",
              query: {
                code: info.Code,
              },
            });
          })
      }
    },
    toSubjectList(code, tcode) {
      this.$router.push({
        path: "subjectList",
        query: {
          code: code,
          tcode: tcode,
        },
      });
    },
    toSquare() {
      this.$dialog
        .alert({
          title: "提示",
          message: "升级中，敬请期待！",
        })
        .then(() => {
          // on close
        });
    },
    toLive() {
      this.$router.push("/obsLive");
    },
    toBanner(type, url, id) {
      if (type == 20) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '栏目Banner',
            TCode: 'subject_banner',
            Rid: id,
          }).then(res => {
            this.$router.push({
              path: 'live',
              query: {
                id: url,
                type: 1
              }
            });
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '栏目Banner',
            TCode: 'subject_banner',
            Rid: id,
          }).then(res => {
            location.href = url;
          })
      }
    },
    toACMEDReg() {
      this.$router.push("/tuiguang");
      // this.$dialog
      //   .alert({
      //     title: "提示",
      //     message: "升级中，敬请期待！",
      //   })
      //   .then(() => { });
    },
    toActivity() {
      this.$router.push("/dahuilist");
      // this.$dialog
      //   .alert({
      //     title: "提示",
      //     message: "升级中，敬请期待！",
      //   })
      //   .then(() => { });
    },
    toACMED() {
      window.location.href = "https://huafui-literature.tv-conf.com/admin";
    },
    toLivelist() {
      this.$router.push({
        path: "liveztList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#launchBtn {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  z-index: 999999999;
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;

  .square_banner {
    background-color: #f7f9fa;
    background-image: url("../../assets/images/square_top_bg.png");
    background-position: top;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 145px;
    padding: 25px 12px 0;

    .bannerBox {
      border-radius: 10px;
      overflow: hidden;
    }

    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }

  .square_content {
    flex: 1;
    height: 0;
    overflow: scroll;

    .square_warp {
      display: flex;
      padding: 14px 12px;

      .square_btn_item {
        position: relative;
        padding: 8px;
        text-align: center;
        flex: 1;
        font-size: 14px;
        color: #1f2b5b;

        img {
          display: block;
          margin: 0 auto 8px;
          width: 48px;
          height: 48px;
        }

        span {
          font-size: 0.35rem;
          font-weight: 600;
        }
      }

      .square_btn_item:not(:last-child)::after {
        content: "";
        display: block;
        height: 16px;
        opacity: 1;
        position: absolute;
        right: 0;
        top: 25px;
        width: 0;
        border-right: 1px solid #efefef;
      }
    }

    .square_consult_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .title {
        color: #1f2b5b;
        font-size: 16px;
        font-weight: 600;
      }

      .more {
        display: flex;
        align-items: center;
        color: #768fa4;
        font-size: 12px;

        .icon {
          color: #768fa4;
          font-size: 10px;
          margin-left: 3px;
        }
      }
    }

    .square_circle {
      margin: 0 12px;

      .square_circle_box {
        margin-bottom: 15px;
        display: flex;

        .page_squareCircle_mask {
          display: flex;
          flex: 1;
          padding: 10px;
          background: #f5f6fa;
          border-radius: 8px;

          .mask_l {
            width: 58px;
            height: 58px;
            border-radius: 4px;
            overflow: hidden;

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }

          .mask_r {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 8px;

            .name {
              color: #333;
              font-size: 14px;
              font-weight: 500;
            }

            .join {
              border: 1px solid #a1a5b9;
              width: 40px;
              height: 18px;
              border-radius: 18px;
              line-height: 18px;
              text-align: center;
              font-size: 10px;
              color: #a1a5b9;

              .icon {
                font-size: 8px;
              }
            }
          }
        }

        .page_squareCircle_mask:nth-child(odd) {
          margin-right: 10px;
        }
      }
    }

    .square_consult {
      margin: 0 12px;

      .square_consult_box {
        .right_Consult {
          display: flex;
          border-radius: 8px;
          box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.04);
          margin-bottom: 10px;
          padding: 10px;
          box-sizing: border-box;

          .base {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;

            .title {
              color: #0c2941;
              font-size: 15px;
              font-weight: 500;
              line-height: 22px;

              .top {
                background: #1f2b5b;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;
                padding: 3px;
                margin-right: 5px;
              }
            }

            .info {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .source_box {
                display: flex;
                align-items: center;
                min-width: 25px;
                max-width: 70%;
                height: 25px;
                border-radius: 25px;
                background: #f6f6f6;

                .source_icon {
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  margin: 0 5px;
                  background-color: #fff;
                }

                .source_title {
                  font-size: 12px;
                  color: #435361;
                  margin: 0 10px 0 5px;
                }
              }

              .time {
                font-size: 12px;
                color: #435361;
              }
            }
          }

          .picture {
            flex-shrink: 0;
            width: 80px;
            height: 80px;
            border-radius: 10px;
            overflow: hidden;
            margin-left: 10px;

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>